import * as t from 'io-ts'

import * as tv from '@espoon-voltti/ts-libs/lib/io-ts-types'

import {
  PayAfterReportDecision,
  PayImmediatelyDecision,
  PayImmediatelyWaitReportDecision,
  RejectedDecision
} from '../../../domain/grants/decision'

export const approvedDecisionData = {
  decidedAt: tv.dateTimeFromString,
  decision: t.union([
    PayAfterReportDecision,
    PayImmediatelyDecision,
    PayImmediatelyWaitReportDecision
  ])
}

export const preReportDecisionData = {
  decidedAt: tv.dateTimeFromString,
  decision: PayAfterReportDecision
}

export const postReportDecisionData = {
  decidedAt: tv.dateTimeFromString,
  decision: PayImmediatelyWaitReportDecision
}

export const preReportOrRejectedDecisionData = {
  decidedAt: tv.dateTimeFromString,
  decision: t.union([PayAfterReportDecision, RejectedDecision])
}
